// extracted by mini-css-extract-plugin
export default {"primary-color":"#384a3a","secondary-color":"#5c605b","golden-color":"#eac37b","light-green-color":"#aaf7b8","golden-disabled-color":"rgba(234,195,123,.2)"};